// extracted by mini-css-extract-plugin
export var divider = "_gv-7";
export var itemsToggle = "_gv-8";
export var mergeModal = "_gv-1";
export var optionCard = "_gv-4";
export var radioGroup = "_gv-6";
export var radioOption = "_gv-0";
export var selected = "_gv-5";
export var shipmentOptions = "_gv-2";
export var tableOptions = "_gv-3";